import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import PracticeAreaCard from './components/PracticeAreaCard';
import FilterSection from './components/FilterSection';
import ContactSidebar from './components/ContactSidebar';
import ContactSection from './components/ContactSection';
import Breadcrumb from './components/Breadcrumb';
import Icon from '../../components/AppIcon';


const PracticeAreasOverview = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const practiceAreas = [
    {
      id: 1,
      name: currentLanguage === 'en' ? 'Corporate Law' : 'Sheria ya Makampuni',
      slug: 'corporate-law',
      category: currentLanguage === 'en' ? 'Corporate' : 'Makampuni',
      icon: 'Building2',
      description: currentLanguage === 'en' ?'Comprehensive corporate legal services including business formation, contract drafting, compliance, mergers and acquisitions, and corporate governance. We help businesses navigate complex regulatory environments and achieve their strategic objectives.' :'Huduma kamili za kisheria za makampuni ikiwa ni pamoja na uundaji wa biashara, uandishi wa mikataba, kufuata sheria, muungano na ununuzi, na utawala wa makampuni. Tunasaidia biashara kupitia mazingira magumu ya kisheria na kufikia malengo yao ya kimkakati.',
      keyServices: [
        currentLanguage === 'en' ? 'Business Formation & Registration' : 'Uundaji na Usajili wa Biashara',
        currentLanguage === 'en' ? 'Contract Drafting & Review' : 'Uandishi na Ukaguzi wa Mikataba',
        currentLanguage === 'en' ? 'Regulatory Compliance' : 'Kufuata Kanuni za Kisheria',
        currentLanguage === 'en' ? 'Mergers & Acquisitions' : 'Muungano na Ununuzi',
        currentLanguage === 'en' ? 'Corporate Governance' : 'Utawala wa Makampuni'
      ],
      typicalCases: [
        currentLanguage === 'en' ? 'Company Registration' : 'Usajili wa Kampuni',
        currentLanguage === 'en' ? 'Partnership Agreements' : 'Mikataba ya Ushirikiano',
        currentLanguage === 'en' ? 'Employment Contracts' : 'Mikataba ya Ajira'
      ],
      filterType: 'corporate',
      complexity: 'intermediate'
    },
    {
      id: 2,
      name: currentLanguage === 'en' ? 'Family Law' : 'Sheria ya Familia',
      slug: 'family-law',
      category: currentLanguage === 'en' ? 'Individual' : 'Binafsi',
      icon: 'Heart',
      description: currentLanguage === 'en' ?'Sensitive and professional handling of family matters including divorce proceedings, child custody arrangements, matrimonial property disputes, adoption processes, and domestic relations. We provide compassionate legal support during difficult times.' :'Kushughulikia kwa unyeti na kitaalamu mambo ya familia ikiwa ni pamoja na michakato ya talaka, mipango ya ulinzi wa watoto, migogoro ya mali za ndoa, michakato ya kupokea watoto, na mahusiano ya nyumbani. Tunatoa msaada wa kisheria wa huruma wakati mgumu.',
      keyServices: [
        currentLanguage === 'en' ? 'Divorce & Separation' : 'Talaka na Kuachana',
        currentLanguage === 'en' ? 'Child Custody & Support' : 'Ulinzi na Msaada wa Watoto',
        currentLanguage === 'en' ? 'Matrimonial Property' : 'Mali za Ndoa',
        currentLanguage === 'en' ? 'Adoption Procedures' : 'Michakato ya Kupokea Watoto',
        currentLanguage === 'en' ? 'Domestic Violence Cases' : 'Kesi za Unyanyasaji wa Nyumbani'
      ],
      typicalCases: [
        currentLanguage === 'en' ? 'Divorce Proceedings' : 'Michakato ya Talaka',
        currentLanguage === 'en' ? 'Custody Disputes' : 'Migogoro ya Ulinzi',
        currentLanguage === 'en' ? 'Property Division' : 'Mgawanyo wa Mali'
      ],
      filterType: 'individual',
      complexity: 'complex'
    },
    {
      id: 3,
      name: currentLanguage === 'en' ? 'Property Law' : 'Sheria ya Mali',
      slug: 'property-law',
      category: currentLanguage === 'en' ? 'Individual & Corporate' : 'Binafsi na Makampuni',
      icon: 'Home',
      description: currentLanguage === 'en' ?'Expert guidance on all property-related matters including real estate transactions, land disputes, property development, landlord-tenant issues, and property investment. We ensure secure and legally compliant property dealings.' :'Mwongozo wa kitaalamu juu ya mambo yote yanayohusiana na mali ikiwa ni pamoja na miamala ya mali isiyohamishika, migogoro ya ardhi, maendeleo ya mali, masuala ya mmiliki-mpangaji, na uwekezaji wa mali. Tunahakikisha miamala ya mali salama na inayofuata sheria.',
      keyServices: [
        currentLanguage === 'en' ? 'Property Transactions' : 'Miamala ya Mali',
        currentLanguage === 'en' ? 'Land Disputes Resolution' : 'Utatuzi wa Migogoro ya Ardhi',
        currentLanguage === 'en' ? 'Title Verification' : 'Uthibitisho wa Hati',
        currentLanguage === 'en' ? 'Landlord-Tenant Law' : 'Sheria ya Mmiliki-Mpangaji',
        currentLanguage === 'en' ? 'Property Development' : 'Maendeleo ya Mali'
      ],
      typicalCases: [
        currentLanguage === 'en' ? 'Property Purchase' : 'Ununuzi wa Mali',
        currentLanguage === 'en' ? 'Land Boundary Disputes' : 'Migogoro ya Mipaka ya Ardhi',
        currentLanguage === 'en' ? 'Lease Agreements' : 'Mikataba ya Kukodisha'
      ],
      filterType: 'individual',
      complexity: 'intermediate'
    },
    {
      id: 4,
      name: currentLanguage === 'en' ? 'Criminal Defense' : 'Utetezi wa Jinai',
      slug: 'criminal-defense',
      category: currentLanguage === 'en' ? 'Individual' : 'Binafsi',
      icon: 'Shield',
      description: currentLanguage === 'en' ?'Robust criminal defense representation for individuals facing criminal charges. We provide strategic defense planning, court representation, plea negotiations, and comprehensive legal support throughout the criminal justice process.' :'Uwakilishi mkuu wa utetezi wa jinai kwa watu binafsi wanaokabiliwa na mashtaka ya jinai. Tunatoa mipango ya kimkakati ya utetezi, uwakilishi wa mahakamani, mazungumzo ya kukubali hatia, na msaada kamili wa kisheria katika mchakato wote wa haki za jinai.',
      keyServices: [
        currentLanguage === 'en' ? 'Criminal Defense Representation' : 'Uwakilishi wa Utetezi wa Jinai',
        currentLanguage === 'en' ? 'Bail Applications' : 'Maombi ya Dhamana',
        currentLanguage === 'en' ? 'Plea Negotiations' : 'Mazungumzo ya Kukubali Hatia',
        currentLanguage === 'en' ? 'Appeals Process' : 'Mchakato wa Rufaa',
        currentLanguage === 'en' ? 'Legal Consultation' : 'Ushauri wa Kisheria'
      ],
      typicalCases: [
        currentLanguage === 'en' ? 'Theft & Fraud Cases' : 'Kesi za Wizi na Ulaghai',
        currentLanguage === 'en' ? 'Assault Charges' : 'Mashtaka ya Kushambulia',
        currentLanguage === 'en' ? 'Traffic Violations' : 'Ukiukaji wa Sheria za Barabarani'
      ],
      filterType: 'litigation',
      complexity: 'complex'
    },
    {
      id: 5,
      name: currentLanguage === 'en' ? 'Employment Law' : 'Sheria ya Ajira',
      slug: 'employment-law',
      category: currentLanguage === 'en' ? 'Individual & Corporate' : 'Binafsi na Makampuni',
      icon: 'Users',
      description: currentLanguage === 'en' ?'Comprehensive employment law services covering workplace disputes, employment contracts, wrongful termination, discrimination cases, and labor relations. We protect both employee rights and employer interests.' :'Huduma kamili za sheria ya ajira zinazoshughulikia migogoro ya kazini, mikataba ya ajira, kufukuzwa kwa makosa, kesi za ubaguzi, na mahusiano ya kazi. Tunalinda haki za wafanyakazi na maslahi ya waajiri.',
      keyServices: [
        currentLanguage === 'en' ? 'Employment Contracts' : 'Mikataba ya Ajira',
        currentLanguage === 'en' ? 'Wrongful Termination' : 'Kufukuzwa kwa Makosa',
        currentLanguage === 'en' ? 'Workplace Discrimination' : 'Ubaguzi Kazini',
        currentLanguage === 'en' ? 'Labor Disputes' : 'Migogoro ya Kazi',
        currentLanguage === 'en' ? 'Employee Benefits' : 'Manufaa ya Wafanyakazi'
      ],
      typicalCases: [
        currentLanguage === 'en' ? 'Unfair Dismissal' : 'Kufukuzwa kwa Udhalimu',
        currentLanguage === 'en' ? 'Salary Disputes' : 'Migogoro ya Mishahara',
        currentLanguage === 'en' ? 'Workplace Harassment' : 'Unyanyasaji Kazini'
      ],
      filterType: 'corporate',
      complexity: 'intermediate'
    },
    {
      id: 6,
      name: currentLanguage === 'en' ? 'Civil Litigation' : 'Mashtaka ya Kiraia',
      slug: 'civil-litigation',
      category: currentLanguage === 'en' ? 'Individual & Corporate' : 'Binafsi na Makampuni',
      icon: 'Scale',
      description: currentLanguage === 'en' ?'Expert representation in civil disputes including contract breaches, tort claims, business disputes, and personal injury cases. We provide strategic litigation support from case assessment to trial representation.' :'Uwakilishi wa kitaalamu katika migogoro ya kiraia ikiwa ni pamoja na ukiukaji wa mikataba, madai ya makosa, migogoro ya biashara, na kesi za majeraha ya kibinafsi. Tunatoa msaada wa kimkakati wa mashtaka kutoka tathmini ya kesi hadi uwakilishi wa mahakamani.',
      keyServices: [
        currentLanguage === 'en' ? 'Contract Disputes' : 'Migogoro ya Mikataba',
        currentLanguage === 'en' ? 'Personal Injury Claims' : 'Madai ya Majeraha ya Kibinafsi',
        currentLanguage === 'en' ? 'Business Litigation' : 'Mashtaka ya Biashara',
        currentLanguage === 'en' ? 'Debt Recovery' : 'Urejeshaji wa Madeni',
        currentLanguage === 'en' ? 'Tort Claims' : 'Madai ya Makosa'
      ],
      typicalCases: [
        currentLanguage === 'en' ? 'Breach of Contract' : 'Ukiukaji wa Mkataba',
        currentLanguage === 'en' ? 'Negligence Claims' : 'Madai ya Uzembe',
        currentLanguage === 'en' ? 'Commercial Disputes' : 'Migogoro ya Kibiashara'
      ],
      filterType: 'litigation',
      complexity: 'complex'
    }
  ];

  const filteredPracticeAreas = practiceAreas.filter(area => {
    const matchesFilter = selectedFilter === 'all' || area.filterType === selectedFilter;
    const matchesCategory = selectedCategory === 'all' || area.complexity === selectedCategory;
    return matchesFilter && matchesCategory;
  });

  return (
    <>
      <Helmet>
        <title>
          {currentLanguage === 'en' ?'Practice Areas - Peter Partners Law Firm' :'Maeneo ya Utendaji - Kampuni ya Sheria ya Peter Partners'}
        </title>
        <meta 
          name="description" 
          content={currentLanguage === 'en' ?'Explore our comprehensive legal practice areas including corporate law, family law, property law, criminal defense, employment law, and civil litigation. Expert legal services in Kenya.' :'Chunguza maeneo yetu kamili ya utendaji wa kisheria ikiwa ni pamoja na sheria ya makampuni, sheria ya familia, sheria ya mali, utetezi wa jinai, sheria ya ajira, na mashtaka ya kiraia. Huduma za kitaalamu za kisheria Kenya.'}
        />
        <meta 
          name="keywords" 
          content={currentLanguage === 'en' ?'legal services Kenya, corporate law, family law, property law, criminal defense, employment law, civil litigation, Peter Partners' :'huduma za kisheria Kenya, sheria ya makampuni, sheria ya familia, sheria ya mali, utetezi wa jinai, sheria ya ajira, mashtaka ya kiraia, Peter Partners'}
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
          <Breadcrumb currentLanguage={currentLanguage} />
          
          {/* Page Header */}
          <div className="text-center mb-12">
            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-text-primary mb-4">
              {currentLanguage === 'en' ? 'Our Practice Areas' : 'Maeneo Yetu ya Utendaji'}
            </h1>
            <p className="text-text-secondary max-w-3xl mx-auto leading-relaxed">
              {currentLanguage === 'en' ?'Peter & Partners Advocates LLP offers comprehensive legal services across multiple practice areas. Our experienced team provides expert guidance and representation tailored to your specific legal needs.' :'Peter & Partners Advocates LLP inatoa huduma kamili za kisheria katika maeneo mengi ya utendaji. Timu yetu ya uzoefu inatoa mwongozo wa kitaalamu na uwakilishi ulioandaliwa kwa mahitaji yako maalum ya kisheria.'}
            </p>
          </div>

          <div className="lg:grid lg:grid-cols-4 lg:gap-8">
            {/* Main Content */}
            <div className="lg:col-span-3">
              <FilterSection
                currentLanguage={currentLanguage}
                selectedFilter={selectedFilter}
                onFilterChange={setSelectedFilter}
                selectedCategory={selectedCategory}
                onCategoryChange={setSelectedCategory}
              />

              {/* Practice Areas Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-8">
                {filteredPracticeAreas.map((practiceArea) => (
                  <PracticeAreaCard
                    key={practiceArea.id}
                    practiceArea={practiceArea}
                    currentLanguage={currentLanguage}
                  />
                ))}
              </div>

              {/* No Results Message */}
              {filteredPracticeAreas.length === 0 && (
                <div className="text-center py-12">
                  <div className="flex items-center justify-center w-16 h-16 bg-surface/20 rounded-full mx-auto mb-4">
                    <Icon name="Search" size={32} className="text-text-secondary" />
                  </div>
                  <h3 className="font-heading font-semibold text-lg text-text-primary mb-2">
                    {currentLanguage === 'en' ? 'No Practice Areas Found' : 'Hakuna Maeneo ya Utendaji Yaliyopatikana'}
                  </h3>
                  <p className="text-text-secondary">
                    {currentLanguage === 'en' ?'Try adjusting your filters to see more results.' :'Jaribu kubadilisha vichungi vyako kuona matokeo zaidi.'}
                  </p>
                </div>
              )}

              {/* Mobile Contact Section */}
              <div className="lg:hidden">
                <ContactSection currentLanguage={currentLanguage} />
              </div>
            </div>

            {/* Desktop Sidebar */}
            <div className="hidden lg:block lg:col-span-1">
              <div className="sticky top-24">
                <ContactSidebar currentLanguage={currentLanguage} />
              </div>
            </div>
          </div>

          {/* Desktop Contact Section */}
          <div className="hidden lg:block">
            <ContactSection currentLanguage={currentLanguage} />
          </div>
        </main>
      </div>
    </>
  );
};

export default PracticeAreasOverview;